import { useUserDetailsContext } from "@zenith/context";
import { UsersApiService } from "@zenith/services/user";

export const useBalanceVisibility = () => {
  const { userDetailsContext, setUserDetailsContext } = useUserDetailsContext();
  const { isBalanceVisible } = userDetailsContext;

  const toggleBalanceVisibility = async () => {
    const newState = !isBalanceVisible;
    setUserDetailsContext({ isBalanceVisible: newState });
    try {
      await UsersApiService.toggleWalletBalance({ showWallet: newState });
    } catch {
      setUserDetailsContext({ isBalanceVisible: !newState });
    }
  };

  return {
    isBalanceVisible,
    toggleBalanceVisibility,
  };
};
